import { ColorClassModifier } from '@applift/factor';

export const colorMappingForPacing: { [key: string]: ColorClassModifier } = {
  success: 'success-500',
  warning: 'warning-500',
  error: 'danger-500',
  secondary: 'neutral-600',
};
